import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BingMapsLoaderService {

  private static url: string;

  private static promise;

  public static load(): Promise<any> {
    // First time 'load' is called?
    if (!BingMapsLoaderService.promise) {

      // Make promise to load
      BingMapsLoaderService.promise = new Promise(resolve => {

        // Set callback for when bing maps is loabing-map.componentded.
        window['__onBingLoaded'] = (ev) => {
          resolve('Bing Maps API loaded');
        };

        const node = document.createElement('script');
        node.src = environment.bingApiUrl + '&callback=__onBingLoaded';
        node.type = 'text/javascript';
        node.async = true;
        node.defer = true;
        document.getElementsByTagName('head')[0].appendChild(node);
      });
    }

    // Always return promise. When 'load' is called many times, the promise is already resolved.
    return BingMapsLoaderService.promise;
  }
}
